import axios from "axios";
import authService from "../../routes/authService"; // CORREÇÃO AQUI

const API_BASE_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = authService.getToken(); // CORREÇÃO AQUI
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const UserService = {
  getAllUsers: async () => {
    try {
      const response = await api.get("/employees");
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar todos os usuários:", error);
      throw error;
    }
  },

  updateUser: async (userData) => {
    try {
      const token = authService.getToken(); // CORREÇÃO AQUI
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      const response = await axios.put(`${API_BASE_URL}/employees`, userData, {
        headers: headers,
      });
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao atualizar usuário:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  getAllOptions: async () => {
    try {
      const response = await api.get("/options");
      return response.data;
    } catch (error) {
      console.error("Erro ao buscar opções (status/cargos):", error);
      throw error;
    }
  },
};

export default UserService;
